import { ECompetitorsLevel } from '../../../../../../../../reducers/v2';
import { ICompetitorServiceIU } from '../types';

export const getCompetitorsLevel = (
  promotions: (ICompetitorServiceIU & { level: ECompetitorsLevel })[],
): ECompetitorsLevel | null => {
  const selectedPromotion = promotions.find(({ selected }) => selected);

  return selectedPromotion ? selectedPromotion.level : null;
};
